
<div class="hbox">
  <div class="flex-box">
    <div class="flex-heading">
      <div class="col-xs-12 list-header">
        <ul class="breadcrumb">
          <li><a routerLink="/products/investigations">Investigations</a></li>
          <li>{{investigationId ? 'Edit' : 'New'}}</li>
        </ul>
      </div>
    </div>
    <div class="flex-content">
      <form class="col-xs-12 p-4" #investigationForm="ngForm">
        <div class="col-xs-12">
          <label class="col-xs-4 mt-0" for="name">Name</label>
          <div class="col-xs-12">
            <input-text class="col-xs-5" [parseObj]="investigation" name="name" placeholder="Name" [required]="true"></input-text>
          </div>
        </div>
        <div class="col-xs-12 mt-3">
          <label class="col-xs-4" for="description">Description</label>
          <div class="col-xs-12">
            <textarea class="col-xs-5" [(ngModel)]="investigation.description" name="description" placeholder="Why are these tests needed?" rows="3"></textarea>
          </div>
        </div>
        <div class="col-xs-12 mt-3">
          <label class="col-xs-4" for="newTest">Tests</label>
          <div class="col-xs-6">
            <div style="display: flex; align-items: center; gap: 8px;">
              <input style="flex: 1;" placeholder="Add test" [(ngModel)]="newTest" name="newTest" (keyup.enter)="addTest()"/>
              <label style="display: flex; align-items: center; gap: 4px; white-space: nowrap; margin: 0; cursor: pointer;">
                <input type="checkbox" [(ngModel)]="newTestRequired" name="newTestRequired"/>Required
              </label>
              <button type="button" class="btn-xxs" (click)="addTest()">Add</button>
            </div>
            <table class="mt-2" style="width: 100%;" *ngIf="tests.length">
              <thead>
                <tr>
                  <th style="text-align: left; padding: 4px 8px; font-weight: 600; border-bottom: 1px solid #ddd;">#</th>
                  <th style="text-align: left; padding: 4px 8px; font-weight: 600; border-bottom: 1px solid #ddd;">Test Name</th>
                  <th style="text-align: center; padding: 4px 8px; font-weight: 600; border-bottom: 1px solid #ddd;">Required</th>
                  <th style="text-align: center; padding: 4px 8px; font-weight: 600; border-bottom: 1px solid #ddd;">Remove</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let test of tests; let i = index">
                  <td style="padding: 4px 8px;">{{i + 1}}</td>
                  <td style="padding: 4px 8px;">{{test.test}}</td>
                  <td style="text-align: center; padding: 4px 8px;">
                    <input type="checkbox" [checked]="test.required" (change)="toggleRequired(i)"/>
                  </td>
                  <td style="text-align: center; padding: 4px 8px;">
                    <i class="fa fa-times pointer text-danger" (click)="removeTest(i)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <span *ngIf="!tests.length" class="text-muted mt-2 db">No tests added</span>
          </div>
        </div>
        <div class="col-xs-12 mt-3">
          <button class="db" [disabled]="!investigationForm.valid" (click)="saveInvestigation()">
            {{investigationId ? 'Update' : 'Create'}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
